import React, { Component } from 'react';
import Utils from 'common/utils'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Constants from 'common/constants'
import CommonComponents from './commonComponents'
import Theme from 'common/theme'
import NativeAgent from 'common/nativeAgent'
import Analytics from 'analytics';


export default class LoaderView extends Component {
    componentDidMount() {
        try {
            // Have to remove all the other themes before adding this
            document.body.classList.remove(...Theme.getAllThemesBodyClasses())
            document.body.classList.add(Theme.getThemeBodyClass());
        } catch (e) {
            console.log("Error applying theme for body")
        }
        // Add refresh handler
        CommonComponents.AddWindowRefreshHandler(this.weatherRefreshHandler.bind(this))

        // Call the native agent 
        NativeAgent.addBlackListBounds("")

        // Analytics event
        Analytics.trackPageView(Constants.ANALYTICS.PAGE_VIEW.LOADING_PAGE)
        Analytics.sendEvent(
            Constants.ANALYTICS.EVENTS.CATEGORY.COMP_LOAD,
            Constants.ANALYTICS.EVENTS.ACTION.COMP_LOADING,
            null,
            null,
            true,
        )
    }

    weatherRefreshHandler() {
        CommonComponents.DefaultRefreshHandler()
    }

    componentWillUnmount() {
        Utils.updateBodyBackgroundImage(null)
    }

    render() {
        var theme = Theme.getThemeBaseClass()
        console.log("THEME: Got theme - ", theme)
        var baseClassesStr = [
            "loader-common",
            "loader-bg",
            theme,
            Theme.getThemeLoaderBase(),
        ].join(" ")
        return (
            <ReactCSSTransitionGroup
                transitionName="fade-in"
                transitionEnter={false}
                transitionLeave={false}
                transitionAppear={true}
                transitionAppearTimeout={Constants.FADE_IN_TRANSITION_TIMEOUT}
            >
                <div className={baseClassesStr}>
                    <div className="location-top-bar"></div>
                    <div className="loader-content-wrapper">
                        <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                        <div className="loader">
                            <strong>
                                {this.props.locationMode===Constants.WEATHER_SRC.MANUAL?"Loading The Weather":"Now fetching accurate weather information for you"}
                            </strong>
                        </div>
                    </div>
                </div>
                {CommonComponents.getBottomBarComponents()}
            </ReactCSSTransitionGroup>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/loaderView.js